<template>
	<div class="w-screen py-3 2xl:px-[28rem] xl:px-64 lg:px-32 px-12 overflow-x-hidden">
        <div class="max-w-7xl mx-auto">
            <slot></slot>
        </div>
	</div>
</template>
